
import { useState, useEffect, useRef } from 'react'
import { Table, Button, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { FaCloudDownloadAlt, FaEllipsisV } from 'react-icons/fa';
import dayjs from 'dayjs';
import { Spinner } from 'react-bootstrap';
import { setLoader } from '../../../Slices/loaderSlice';
import { useErrorLogger } from '../../../utils';
import { fetchAllAttachments, insertAttachmentThunk, modifyAttachmentDetailsThunk } from '../../../Slices/Thunk/employeeThunk';
import axios from 'axios';
import { SERVER_URL } from '../../../databucket';
import { Dropdown, } from 'react-bootstrap';
import Link from 'antd/es/typography/Link';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import {S3ACCESSURL} from '../../../databucket';
export default function AttachmentsHistory() {
  const [Attachments, setAttachments] = useState([]);
  const { logError } = useErrorLogger();
  const [allHistoryRecords, setAttachmentsHistory] = useState([]);// Use props directly without renaming
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const { Empid } = useParams();
  const fileInputRefUpdate = useRef(null);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const id = loginUser?.id;
  const ids = Empid || id;
  const details = useSelector((state) => state.employee.AllEmployees);
  const employee = details?.find((emp) => emp?.id === id);
  const attachments = useSelector((state) => state?.Attachments?.attachments);
  const attachmentsHistory = useSelector((state) => state.Attachments?.attachmentsHistory);
   useEffect(() => {
    (()=>{
    setAttachments([attachments]);
    setAttachmentsHistory([attachmentsHistory]);
    })()
  }, [attachments, attachmentsHistory]);

  const handleMultipleAttachment = async (event) => {
    const multipleFiles = Array.from(event.target.files);
    const formData = new FormData();
    multipleFiles.forEach(file => formData.append('files', file));

    try {
      dispatch(setLoader(true));
      const res = await axios.post(`${SERVER_URL}/upload`, formData);
      const uploadedFiles = res.data.files.map(uploadedItem => ({
        userId: loginUser?.id,
        emailId: Empid ? Empid : loginUser?.id,
        data: uploadedItem.url,
        replacedFile: null,
        userName: `${employee?.firstname}${employee?.lastname}`,
        filename: uploadedItem.originalName,
        mimetype: uploadedItem.mimeType,
        addDate: Date.now().toString(),
        updateDate: null,
        status: true,
        deleteDate: null,
        attachmetHistory: [  // Add the history here
          {
            userId: loginUser?.id,
            emailId: Empid ? Empid : loginUser?.id,
            replacedFile: null,
            data: uploadedItem.url,
            userName: `${employee?.firstname}${employee?.lastname}`,
            filename: uploadedItem.originalName,
            mimetype: uploadedItem.mimeType,
            addDate: Date.now().toString(),
            updateDate: null,
            status: true,
            deleteDate: null,
          }
        ]
      }));
      await dispatch(insertAttachmentThunk( {id: ids, valuesObject: uploadedFiles }));
      await dispatch(fetchAllAttachments({ID:ids}))
      message.success({
        content: "Attachment Inserted Successfully",
        duration: 5
      })
    } catch (error) {
      console.error(error);
      await logError("AttachmentHistory", "handleMultipleAttachment", error.message);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleUpdateAttachment = async (row) => {
    const selectedFile = await new Promise((resolve) => {
      const inputElement = fileInputRefUpdate.current;
      if (!inputElement) return;
      inputElement.onchange = (event) => resolve(event.target.files[0]);
      inputElement.click();
    });

    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('files', selectedFile);
    try {
      dispatch(setLoader(true));
      const res = await axios.post(`${SERVER_URL}/upload`, formData);
      const savedFile = res.data.files[0];
      const valuesObject = {
        userId: loginUser?.id,
        replacedFile: row.filename,
        emailId: Empid ? Empid : loginUser?.id,
        data: savedFile.url,
        userName: `${employee?.firstname}${employee?.lastname}`,
        filename: savedFile.originalName,
        mimetype: savedFile.mimeType,
        addDate: null,
        updateDate: Date.now().toString(),
        status: true,
        deleteDate: null
      };
      await dispatch(modifyAttachmentDetailsThunk({ id: row?.id, input: valuesObject }))
      await dispatch(fetchAllAttachments({ID:ids}))
      message.success({
        content: "Attachment Replaced Successfully",
        duration: 5
      })
    } catch (error) {
      console.error('Error updating attachment:', error);
      await logError("AttachmentHistory", "handleUpdateAttachments", error.message);
    } finally {
      dispatch(setLoader(false));
    }
  };
  const deleteHandler = async (attachmentId) => {
    try {
      const valuesObject = {
        userId: loginUser?.id,
        oldfile: attachmentId.oldfile,
        emailId: Empid ? Empid : loginUser?.id,
        data: attachmentId.data,
        userName: `${employee?.firstname}${employee?.lastname}`,
        filename: attachmentId.filename,
        mimetype: attachmentId.mimeType,
        status: false,
        deleteDate: Date.now().toString()
      };
      await dispatch(modifyAttachmentDetailsThunk({ id: attachmentId?.id, input: valuesObject }))
      await dispatch(fetchAllAttachments({ID:ids}))
      message.success({
        content: "Attachment Deleted Successfully",
        duration: 5
      })
    } catch (error) {
      console.error("Error deleting attachment:", error);
      await logError("AttachmentHistory", "Delelte", error.message);
    }
  };
  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(S3ACCESSURL+fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      await logError("AttachmentHistory", "handleDownload", error.message);
    }
  };
  function addSpaceBeforeCapitalLetters(userName) {
    if (!userName) return "";
    return userName.replace(/([A-Z])/g, ' $1').trim();
  }
  return (
    <>
      <>
        <div className="col-md-12 d-flex overflow-hidden" >
          <div className="card profile-box flex-fill">
            <div className="card-body">
              <h3 className="card-title" style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                Attachments

                <div style={{ display: 'flex', gap: '1rem' }}>
                  <Col style={{ color: "#4A90E2", cursor: "pointer" }}>
                    <input
                      type="file"
                      multiple
                      ref={fileInputRef}
                      onChange={handleMultipleAttachment}
                      style={{ display: 'none' }}
                    />
                    <Link onClick={() => fileInputRef.current && fileInputRef.current.click()}>
                      <i
                        className="fa-regular fa-folder-open"
                        style={{
                          fontSize: "20px",

                        }}
                        aria-label="Add Multiple Attachments"
                      />
                    </Link>
                  </Col>


                </div>
              </h3>

              <Table responsive>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'start' }}>Attachments</th>
                    <th style={{ textAlign: 'center' }}>Add Date</th>
                    <th style={{ textAlign: 'center' }}>User Name</th>
                    <th style={{ textAlign: 'center' }}>Actions</th>
                    <th style={{ textAlign: 'center' }}>Options</th>
                  </tr>
                </thead>
                {false ? (
                  <tbody>
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '50px 0' }}>
                        <div className="d-flex justify-content-center align-items-center">
                          <Spinner animation="border" role="status" variant="primary" className="text-primary">
                            <span className="visually-hidden">Uploading...</span>
                          </Spinner>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {Attachments?.flat()?.reverse()?.map((row, key) => (
                      row?.status && (
                        <tr key={key}>
                          <td>
                            <a href={S3ACCESSURL+row.data} target="_blank" rel="noopener noreferrer">
                              {row.filename}
                            </a>
                          </td>

                          <td align="center">{!row.updateDate ? dayjs(parseInt(row.addDate)).format("DD/MM/YYYY hh:mm:ss a") : dayjs(parseInt(row.updateDate)).format("DD/MM/YYYY")}</td>
                          <td align="center">{addSpaceBeforeCapitalLetters(row.userName)}
                          </td>
                          <td align="center">
                            <Button variant="primary" onClick={() => handleDownload(row.data, row.filename)}>
                              <FaCloudDownloadAlt /> Download
                            </Button>
                          </td>
                          <td align="center">
                            <Dropdown drop="end">
                              <Dropdown.Toggle as="span" style={{ cursor: 'pointer' }}>
                                <FaEllipsisV size={16} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleUpdateAttachment(row)}>
                                  Replace
                                </Dropdown.Item>
                                <input
                                  type="file"
                                  ref={fileInputRefUpdate}
                                  style={{ display: 'none' }}
                                />
                                <Dropdown.Item onClick={() => deleteHandler(row)}>
                                  Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    ))}
                  </tbody>
                )}
              </Table>

            </div>
          </div>
        </div>
        <div className="col-md-12 d-flex overflow-hidden" >
          <div className="card profile-box flex-fill">
            <div className="card-body">

              <h3 className="card-title" style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                Attachments History
              </h3>
              <Table responsive>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>S.No</th>
                    <th style={{ textAlign: 'center' }}>Attachments</th>
                    <th style={{ textAlign: 'center' }}>User Name</th>
                    <th style={{ textAlign: 'center' }}>Actions</th>
                    <th style={{ textAlign: 'center' }}>Action Date</th>
                  </tr>
                </thead>
                <tbody>
                  {allHistoryRecords?.flat()?.reverse()?.map((row, key) => (
                    <tr key={key}>
                      <td align="center">{key + 1}</td>
                      <td align="center">
                          {row.updateDate ? row.replacedFile + "--->" + row.filename : row.filename}
                      </td>
                      <td align="center">{addSpaceBeforeCapitalLetters(row.userName)}
                      </td>
                      {/* <td align="center">
                        {dayjs(parseInt(row.addDate)).format('DD/MM/YYYY hh:mm:ss:a')}
                      </td> */}
                      <td align="center">
                        {row.status ? row.updateDate ? "Updated" : "created" : "Deleted"}
                      </td>
                      <td align="center">{row.updateDate ? dayjs(parseInt(row.updateDate)).format("DD/MM/YYYY hh:mm:ss a") : !row.deleteDate ? dayjs(parseInt(row.addDate)).format("DD/MM/YYYY hh:mm:ss a") : dayjs(parseInt(row.deleteDate)).format("DD/MM/YYYY hh:mm:ss a")}</td>
                    </tr>

                  ))}
                </tbody>
              </Table>
            </div>
          </div>

        </div>
      </>
    </>

  );
}

